<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar title="工程管理" left-arrow @click-left="$router.go(-1)" />
		</div>
		<div style="height: 46px;"></div>
		<div class='project_box'>
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
				<div v-for='item in list' class='project_list' @click="detail(item.id)">
					<div class='project_list_head ui-flex'>
					    <div class='c_999 ui-flex-1'>{{$formatDate(item.createTime,'yyyy-MM-dd hh:mm')}}</div>
					    <div>
					        <span class="c_warning" v-if="item.projectStatus == 1">待审核</span>
					        <span class="c_success" v-if="item.projectStatus == 2">审核通过</span>
					        <span class='c_warning' v-if="item.projectStatus == 3">驳回</span>
					    </div>
					</div>  
					<div class="project_info gd-icon">
						<div class="project_info_item ui-flex">
							<div class="project_info_lab">工程名称：</div>
							<div class="project_info_val ui-flex-1">{{item.projectName}}</div>
						</div>
						<div class="project_info_item ui-flex">
							<div class="project_info_lab">工程地址：</div>
							<div class="project_info_val ui-flex-1">{{item.projectAddr}}</div>
						</div>
						<div class="project_info_item ui-flex">
							<div class="project_info_lab">施工公司：</div>
							<div class="project_info_val ui-flex-1">{{item.projectCompany}}</div>
						</div>
		
					</div>
				</div>
			</van-list>
		</div>
		
		<div style='height:96px;'></div>
		<div class='bottom_fixed'>
			<van-button type="primary" icon="plus" color="#2f86f6" round block to="/home/project/add">添加</van-button>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				pageNo : 1,
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.loading = true;
				this.$get("/gtb/home/getYqbJabInvoiceProjects.html", { pageNo : this.pageNo }).then(res => {
					this.loading = false;
					if( res.success ){
						const pList = res.pList.pageRecords;
						this.list = this.list.concat(pList);
						this.pageNo = this.pageNo + 1;
						this.finished = this.list.length >= res.pList.totalSize;
					}
				}).catch(error=>{
					this.loading = false;
				});
			},
			detail(id){
				this.$router.push('/home/project/detail?id=' + id);
			}
		},
	};
</script>
<style scoped>
	.project_box{ padding: 16px;}
	.project_list{ padding: 16px;background: #fff;position: relative; margin-bottom: 10px; border-radius: 9px;}
	.project_list_head { margin-bottom: 10px; line-height: 20px;}
	.project_info{ position: relative;padding-right: 16px;}
	.project_info_item{ margin-bottom: 2px;}
	.project_info_lab{ color: #666;}
	.bottom_fixed{ position: fixed; width: 100%; bottom: 0; padding: 16px; }
</style>